"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentUrlAndCopyToClipboard = void 0;
var fallbackCopyToClipboard = function (url) {
    var placeholder = document.createElement("textarea");
    placeholder.value = url;
    // Avoid scrolling to bottom
    placeholder.style.top = "0";
    placeholder.style.left = "0";
    placeholder.style.position = "fixed";
    // Append element, and focus
    document.body.appendChild(placeholder);
    placeholder.focus();
    placeholder.select();
    // Finally, remove element after copy
    document.body.removeChild(placeholder);
};
var getCurrentUrlAndCopyToClipboard = function () {
    var url = window.location.href;
    if (!navigator.clipboard)
        fallbackCopyToClipboard(url);
    else
        navigator.clipboard.writeText(url);
    return url;
};
exports.getCurrentUrlAndCopyToClipboard = getCurrentUrlAndCopyToClipboard;
exports.default = exports.getCurrentUrlAndCopyToClipboard;
//# sourceMappingURL=getCurrentUrlAndCopyToClipboard.js.map